import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {keyAPI} from "../api/api";
import {KeyActionTypes} from "../actions/actionTypes";
import _ from "lodash";

function* getKeyRequests(action) {
    try {
        const requestsResponse = yield call(() =>
            keyAPI.getKeyRequests({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top
            })
        );
        if (requestsResponse.data['results'].length > 0) {
            const userIds: number[] = requestsResponse.data["results"].reduce(
                (accumulator, activity) => {
                    if (activity.user_id && !accumulator.includes(activity.user_id)) {
                        accumulator.push(activity.user_id);
                    }
                    return accumulator;
                },
                []
            );

            if (userIds.length > 0) {
                try {
                    const usersResponse = yield call(() =>
                        keyAPI.getHistoryUsersById({
                            ids: userIds
                        })
                    );

                    requestsResponse.data["results"] = requestsResponse.data[
                        "results"
                        ].map(log => {
                        log.user = _.find(usersResponse.data["results"], {
                            id: log.user_id
                        });
                        return log;
                    });

                    yield put({
                        type: KeyActionTypes.GET_REQUESTS_SUCCESS,
                        payload: {
                            requests: requestsResponse.data
                        }
                    });
                } catch (e) {
                    API.handleError(e.response, "Error getting Users Info.");

                    yield put({
                        type: KeyActionTypes.GET_REQUESTS_FAIL,
                        message: e.message
                    });
                }
            } else {
                API.handleError(null, "Error getting request history list.");

                yield put({
                    type: KeyActionTypes.GET_REQUESTS_FAIL,
                    message: null
                });
            }
        } else {
            yield put({
                type: KeyActionTypes.GET_REQUESTS_SUCCESS,
                payload: {
                    requests: requestsResponse.data
                }
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting request history list.");

        yield put({
            type: KeyActionTypes.GET_REQUESTS_FAIL,
            message: e.message
        });
    }
}

export function* getKeyRequestsWatcher() {
    yield takeLatest(KeyActionTypes.GET_REQUESTS, getKeyRequests);
}
